import { normalizeRoleLevel } from "utils/roleUtils";

const ROLE_LEVEL_ROUTE_MAP = {
  1: "/marketingdataanalysis",
  2: "/marketingdataanalysis",
  3: "/marketingdataanalysis",
  4: "/warehouses",
  5: "/warehouses-realtime",
};

const DEFAULT_ROUTE = "/marketingdataanalysis";

const getDefaultPathByRole = (roleLevelValue) =>
  ROLE_LEVEL_ROUTE_MAP[normalizeRoleLevel(roleLevelValue)] || DEFAULT_ROUTE;

export default getDefaultPathByRole;
